import * as React from 'react';
import { Outlet } from 'react-router-dom';

export const BlankLayout: React.FunctionComponent = function () {
    return <Outlet />;
};
